import styles from './Text.module.scss';
import { firstUpperString } from '../../FirstUpper';
import React, { ReactNode } from 'react';
import NoEscape from '../../NoEscape';
import Tooltip from '../../Popup/Tooltip';
import useTranslation from '../../../Hooks/useTranslation';

interface TextProps {
	tx?: string;
	className?: string;
	style?: any;
	inline?: boolean;
	firstUpper?: boolean;
	children?: string | React.ReactChild | React.ReactChild[];
	truncate?: number;
	colon?: boolean;
	noEscape?: boolean;
	txParams?: Record<string, string | number>;
}

const Text: React.FC<TextProps> = props => {
	const {
		className,
		style,
		inline,
		firstUpper,
		children,
		truncate,
		noEscape,
		colon,
		txParams,
	} = props;
	let { tx = '' } = props;
	const { t } = useTranslation();

	const classes = `${className || ''} ${styles.p}`;

	if (children) {
		if (typeof children !== 'string') {
			return (
				<>
					{React.Children.map(children, child => {
						if (React.isValidElement(child)) {
							return React.cloneElement(child);
						}
						return child;
					})}
				</>
			);
		} else {
			tx = children;
		}
	}

	const translatedString = t(tx, txParams);
	let finalString = translatedString;

	if (truncate) {
		finalString = truncateString(translatedString, truncate);
	}

	if (colon) {
		finalString += ':';
	}

	let txElement: string | ReactNode = finalString;

	if (firstUpper) {
		txElement = firstUpperString(finalString);
	}

	let component = undefined;

	if (inline) {
		component = (
			<span className={classes} style={style}>
				{txElement}
			</span>
		);
	} else {
		component = (
			<p className={classes} style={style}>
				{txElement}
			</p>
		);
	}

	if (noEscape) {
		component = <NoEscape className={classes}>{txElement}</NoEscape>;
	}

	if (truncate) {
		component = <Tooltip trigger={component}>{translatedString}</Tooltip>;
	}

	return component;
};

function truncateString(text: string, maxLen: number) {
	if (text.length <= maxLen) {
		return text;
	}
	return text.slice(0, maxLen) + '...';
}

export default Text;
